import { FC } from 'react';
import cn from 'classnames';
import {
  AccordionItemContentType,
  AccordionHeaderContent
} from '../../api/types';

interface Props {
  info: { body: AccordionItemContentType[]; header: AccordionHeaderContent };
  onToggle: () => void;
  active: boolean;
  isClosedState?: boolean;
  classNameItem?: string;
  classNameButton?: string;
  renderItem: (content: AccordionItemContentType[]) => JSX.Element;
  renderHeader: (
    content: AccordionHeaderContent,
    productsList: AccordionItemContentType[],
    active: boolean
  ) => JSX.Element;
}
const AccordionItem: FC<Props> = ({
  info,
  onToggle,
  active,
  renderItem,
  isClosedState,
  renderHeader,
  classNameItem,
  classNameButton
}: Props) => {
  const { header, body } = info;
  const classItemWithShadow = cn(
    !isClosedState && 'z-50',
    !isClosedState && active && 'active'
  );
  return (
    <li className={cn(`static`, classNameItem, classItemWithShadow)}>
      <button
        className={cn(
          `w-full flex justify-between items-center`,
          active && 'border-none',
          classNameButton
        )}
        onClick={onToggle}
      >
        {renderHeader(header, body, active)}
      </button>
      <div
        className={cn(
          'bg-white transition-height duration-500 ease-in-out',
          active ? 'overflow-auto h-auto' : 'overflow-hidden h-0'
        )}
      >
        <div>{renderItem(body)}</div>
      </div>
    </li>
  );
};

export default AccordionItem;
